//@flow
import React from 'react';
import './styles.scss';

export const HotspotOverlayMobile = (props: Props) => {
  const {
    data: {
      mobileImage,
      mobileDescription,
      heading,
      indoorParameter,
      indoorSpaces,
      outdoorParameter,
      outdoorSpaces,
    },
  } = props;

  return (
    <>
      <div className={'mobile-hotspot-image'}>
        <img src={mobileImage} alt="NO image present" />
      </div>

      <div className={'mobile-hotspot-details'}>
        <h2>{heading}</h2>
        <div className={'mobile-hotspot-area-specifications'}>
          {outdoorSpaces && (
            <>
              <div className={'outdoor-area'}>
                <span>OUTDOOR SPACES</span>
                <div className={'area-values'}>
                  <h2>{outdoorSpaces}</h2>&nbsp; <p>{outdoorParameter}</p>
                </div>
              </div>
            </>
          )}
          {indoorSpaces && (
            <>
              <div className={'indoor-area'}>
                <span>INDOOR SPACES</span>
                <div className={'area-values'}>
                  <h2>{indoorSpaces}</h2> &nbsp; <p>{indoorParameter}</p>
                </div>
              </div>
            </>
          )}
        </div>
        <p>{mobileDescription}</p>
      </div>
    </>
  );
};
